import * as React from 'react';
import CommonPageWithRoutedDrawer from '../common/CommonPageWithRoutedDrawer';
import WorkcalendarList from './WorkcalendarList';
import WorkcalendarForm from './WorkcalendarForm';


const WorkcalendarsPage = (props) => {
    return (
        <CommonPageWithRoutedDrawer
            MainContent={ WorkcalendarList }
            DrawerContentForm={ WorkcalendarForm }
            {...props} />
    );
}

export default WorkcalendarsPage